import { Avatar, Box, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
  IDepartment,
  ISubCategory,
  ISubject,
} from 'API/UniversalRequest/universalRequest';
import { useIsDesktop } from 'Hooks';
import { LeftArrow } from 'Images';
import { TAB_VALUE_TYPE } from 'Modules/UniversalRequest';
import { useEffect, useState } from 'react';

interface IParentCategoriesItemSubcategoriesList {
  category: ISubject | IDepartment;
  onClick: (subCategoryId: number) => void;
  svgIcon: string;
  tabValue: TAB_VALUE_TYPE;
  subCategories?: ISubCategory[];
}

export const ParentCategoriesItemSubcategoriesList = ({
  category,
  onClick,
  svgIcon,
  tabValue,
  subCategories,
}: IParentCategoriesItemSubcategoriesList) => {
  const [sortedSubCategories, setSortedSubCategories] = useState<
    ISubCategory[]
  >([]);

  const isDesktop = useIsDesktop();

  const RemunerationOfficersCategoryId = 4;
  const isRemunerationOfficers =
    tabValue === TAB_VALUE_TYPE.DEPARTMENT &&
    category.id === RemunerationOfficersCategoryId;

  let remunerationOfficers = {
    title: '',
    subTitle: '',
  };
  if (isRemunerationOfficers) {
    const titles = category.title.split(' (');
    titles[1] = '(' + titles[1];
    remunerationOfficers.title = titles[0];
    remunerationOfficers.subTitle = titles[1];
  }

  useEffect(() => {
    const newSortedSubCategories: ISubCategory[] = [];
    category.subSubjectIds.forEach((subSubjectId) => {
      const currentSubCategory = subCategories?.find(
        (subCategory) => subCategory.id === subSubjectId,
      );
      if (currentSubCategory && !currentSubCategory.isHideInClient)
        newSortedSubCategories.push(currentSubCategory);
    });
    setSortedSubCategories(newSortedSubCategories);
  }, [category.subSubjectIds, subCategories]);

  return !isDesktop ? (
    <Grid
      container
      sx={{
        width: '100%',
        margin: '16px 0px 0px',
        padding: 0,
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          gap: '16px',
          alignItems: 'center',
        }}
      >
        <Avatar
          src={svgIcon}
          alt=''
          sx={{
            width: '40px',
            height: '40px',
          }}
        />
        <Typography variant='h6'>{category.title}</Typography>
      </Stack>
      {sortedSubCategories?.map((subCategory, index) => (
        <Grid
          key={index}
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            p: '8px 8px 0 0',
          }}
          size={6}
        >
          <Box
            sx={{
              width: '100%',
              padding: 1,
              bgcolor: 'white',
              boxShadow: '0px 4px 16px rgba(8, 30, 84, 0.12)',
              border: '1px solid #B7CCFF',
              borderRadius: '10px',
              cursor: 'pointer',
              p: '12px 26px',
              m: '6px',
            }}
            onClick={() => onClick(subCategory.id)}
          >
            <Typography variant='body2' sx={{ fontWeight: '600' }}>
              {subCategory.title}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  ) : (
    <Stack
      sx={{
        justifyContent: isDesktop ? 'flex-start' : 'center',
        gap: '24px',
        columnGap: isDesktop ? undefined : '16px',
        mt: '28px',
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          gap: '16px',
        }}
      >
        <Avatar
          src={svgIcon}
          alt=''
          sx={{
            width: '40px',
            height: '40px',
          }}
        />
        <Typography variant='h6'>{category.title}</Typography>
      </Stack>
      <Stack
        direction='row'
        sx={{
          width: isDesktop ? '872px' : '100%',
          alignItems: 'center',
          justifyContent: 'flex-start',
          flexWrap: 'wrap',
          p: '0 auto',
          gap: '16px',
          columnGap: isDesktop ? undefined : '16px',
        }}
      >
        {sortedSubCategories?.map((subCategory) => (
          <Stack
            onClick={() => onClick(subCategory.id)}
            tabIndex={0}
            role='button'
            onKeyDown={(e) => e.key === 'Enter' && onClick(subCategory.id)}
            sx={{
              width: isDesktop ? '280px' : '155px',
              height: isDesktop ? '80px' : '72px',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: 'white',
              boxShadow: '0px 4px 16px rgba(8, 30, 84, 0.12)',
              border: '1px solid #B7CCFF',
              borderRadius: '10px',
              p: isDesktop ? '20px 16px' : '0 26px',
              flexDirection: 'row',
              cursor: 'pointer',
            }}
          >
            <Typography variant='body2'>{subCategory.title}</Typography>
            {isDesktop && (
              <Avatar
                src={LeftArrow}
                alt=''
                sx={{
                  width: '32px',
                  height: '32px',
                }}
              />
            )}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
